import React from "react";
import { cardClass } from "./jobUtils";

export default function StatCard({ label, value, highlight = false }) {
  return (
    <div className={`${cardClass} p-4`}>
      <p className="text-xs uppercase tracking-wide text-gray-400">{label}</p>
      <p className={`text-3xl font-extrabold mt-1 ${highlight ? "text-accent-light" : "text-white"}`}>{value ?? "–"}</p>
    </div>
  );
}
